import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';

// Main pages
import Homepage from './pages/homepage';
import InteractiveConservationMap from './pages/interactive-conservation-map';
import SiteShowcaseGallery from './pages/site-showcase-gallery';
import AgricultureShowcase from './pages/agriculture-showcase';
import TourismActivitiesHub from './pages/tourism-activities-hub';
import SolarFarmsInitiative from './pages/solar-farms-initiative';
import BiodiversityStatusCenter from './pages/biodiversity-status-center';
import VisitorPlanningHub from './pages/visitor-planning-hub';
import VisitorAnalyticsDashboard from './pages/visitor-analytics-dashboard';
import EmergencyAlertSystem from './pages/emergency-alert-system';
import ResearchDataPortal from './pages/research-data-portal';
import CommandCenterDashboard from './pages/command-center-dashboard';
import CommunityEngagementPlatform from './pages/community-engagement-platform';
import MarineTurtleConservation from './pages/marine-turtle-conservation';

// Auth pages
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import Profile from './pages/auth/Profile';

// Error page
import NotFound from './pages/NotFound';

export default function Routes() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ErrorBoundary>
            <ScrollToTop />
            <RouterRoutes>
              {/* Homepage */}
              <Route path="/" element={<Homepage />} />
              
              {/* Main Application Routes - All 10 screens publicly accessible */}
              <Route path="/interactive-conservation-map" element={<InteractiveConservationMap />} />
              <Route path="/site-showcase-gallery" element={<SiteShowcaseGallery />} />
              <Route path="/agriculture-showcase" element={<AgricultureShowcase />} />
              <Route path="/tourism-activities-hub" element={<TourismActivitiesHub />} />
              <Route path="/solar-farms-initiative" element={<SolarFarmsInitiative />} />
              <Route path="/biodiversity-status-center" element={<BiodiversityStatusCenter />} />
              <Route path="/visitor-planning-hub" element={<VisitorPlanningHub />} />
              <Route path="/visitor-analytics-dashboard" element={<VisitorAnalyticsDashboard />} />
              <Route path="/emergency-alert-system" element={<EmergencyAlertSystem />} />
              <Route path="/research-data-portal" element={<ResearchDataPortal />} />
              <Route path="/command-center-dashboard" element={<CommandCenterDashboard />} />
              <Route path="/community-engagement-platform" element={<CommunityEngagementPlatform />} />
              <Route path="/marine-turtle-conservation" element={<MarineTurtleConservation />} />

              {/* Authentication Routes */}
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/profile" element={<Profile />} />

              {/* 404 - Not Found */}
              <Route path="*" element={<NotFound />} />
            </RouterRoutes>
          </ErrorBoundary>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}